export default __webpack_public_path__ + "static/media/mobile.e0ca84f7.jpg";